import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';

const LoadingForButtonLottie = ({ width, height }) => {
  const loadingLottieRef = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: loadingLottieRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      // eslint-disable-next-line global-require
      animationData: require('Assets/Animations/loading_for_button_gray.json'),
    });
  }, []);

  return <LoadingForButtonLottieBox ref={loadingLottieRef} width={width} height={height} />;
};

LoadingForButtonLottie.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

LoadingForButtonLottie.defaultProps = {
  width: 16,
  height: 16,
};

const LoadingForButtonLottieBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};
`;

export default LoadingForButtonLottie;
